export const BEACON_PATH = "/api/fs";
export const VISITOR_COOKIE = "fs_visitor_id";
export const SESSION_COOKIE = "fs_session_id";
export const MAX_BATCH_EVENTS = 10;
export const MAX_BODY_BYTES = 32_768;
export const ID_PATTERN = /^[a-f0-9-]{36}$/i;
export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export const CLIENT_EVENTS = [
  "$pageview", "$pageleave", "page_engagement",
  "genre_calendar_viewed", "genre_calendar_preview_started", "genre_calendar_ticket_clicked", "genre_calendar_event_clicked",
  "discovery_page_viewed", "discovery_event_viewed", "discovery_player_opened", "discovery_listen_requested",
  "discovery_ticket_clicked", "discovery_webmcp_tool_called", "discovery_webmcp_tool_completed",
] as const;

export const PROPERTY_KEYS = new Set([
  "city", "genre", "page", "date_filter", "view", "source", "event_id", "artist_id", "destination", "path",
  "page_kind", "tool", "success", "result_count", "error", "discovery_source", "discovery_source_evidence", "discovery_started_at",
  "duration_ms", "engagement_time_msec",
]);

export type Properties = Record<string, string | number | boolean | null | undefined>;
export type Qualification = "trusted-activity" | "focused-dwell";
export interface PageContext {
  path: string;
  pageviewId: string;
  title: string;
  referrer: string;
  querystring: string;
  language: string;
  timezone: string;
  screenWidth: number;
  screenHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  webdriver: boolean;
  qualification?: Qualification;
  focusedMs?: number;
}
export interface BrowserEvent {
  event: (typeof CLIENT_EVENTS)[number];
  timestamp: number;
  context: PageContext;
  properties: Properties;
}
export interface BeaconPayload {
  visitorId: string;
  sessionId: string;
  sentAt: number;
  events: BrowserEvent[];
}

export function safeReferrer(value: string): string {
  try {
    const url = new URL(value);
    return /^https?:$/.test(url.protocol) ? `${url.origin}${url.pathname}`.slice(0, 2048) : "";
  } catch { return ""; }
}

export function utmQuerystring(value: string): string {
  const source = new URLSearchParams(value);
  const result = new URLSearchParams();
  for (const key of UTM_KEYS) {
    const item = source.get(key)?.slice(0, 256);
    if (!item) continue;
    result.set(key, item);
    if (result.toString().length > 2048) result.delete(key);
  }
  return result.toString();
}

export function safeProperties(properties: Properties): Properties {
  const result: Properties = {};
  for (const [key, value] of Object.entries(properties)) {
    if (!PROPERTY_KEYS.has(key) || value === null || value === undefined) continue;
    if (typeof value === "number" && Number.isFinite(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER) result[key] = value;
    else if (typeof value === "boolean") result[key] = value;
    else if (typeof value === "string") result[key] = key === "path" ? value.split(/[?#]/, 1)[0].slice(0, 2048) : value.slice(0, 256);
  }
  return result;
}
